export const baseUrl = process.env.REACT_APP_BASE_URL || "";
export const webUrl = process.env.REACT_APP_WEB_URL || "";
export const s3Url = process.env.REACT_APP_S3_URL || "";
export const googleApiKey = process.env.REACT_APP_GOOGLE || "";
export const googleAuthClientId = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID || "";
export const googleAuthClientSecret = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_SECRET || "";
export const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID || "";
export const eventBriteKey = process.env.REACT_APP_EVENT_BRITE_API_KEY || "";
export const meetupKey = process.env.REACT_APP_MEETUP_API_KEY || "";
